module.exports = __webpack_public_path__ + "static/ultra-obstetrica-b-52e5406d58faba94034eed0adb290cc4.jpg";